(() => {
  const labelTemplate = document.getElementById('vwd-compare-control-template');
  if (!labelTemplate || !document.querySelector('compare-drawer')) return;
  let resourcesPromise;
  const ensureReady = () => {
    if (customElements.get('compare-drawer') && customElements.get('compare-modal')) return Promise.resolve();
    if (resourcesPromise) return resourcesPromise;
    resourcesPromise = (async () => {
      const resourcesTag = document.getElementById('compare-resources');
      if (resourcesTag) {
        const resources = JSON.parse(resourcesTag.textContent);
        resourcesTag.remove();
        for (const resource of resources) {
          if (resource.type === 'css') {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = resource.path;
            document.head.append(link);
          } else {
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = resource.path;
              script.onload = resolve;
              script.onerror = reject;
              document.head.append(script);
            });
          }
        }
      }
      await Promise.all([customElements.whenDefined('compare-drawer'), customElements.whenDefined('compare-modal')]);
    })();
    return resourcesPromise;
  };
  const sync = () => {
    const selected = theme.storageUtil.get('compare-products', true) || [];
    document.querySelectorAll('.vwd-compare-control .js-compare-checkbox').forEach(input => {
      input.checked = selected.some(product => String(product.id) === input.dataset.productId);
    });
  };
  let sequence = 0;
  const addControls = root => {
    root.querySelectorAll('product-card').forEach(card => {
      if (card.querySelector('.js-compare-checkbox')) return;
      const link = card.querySelector('a.js-prod-link');
      const form = card.querySelector('form[id^="quick-add-"]');
      const productId = card.dataset.productId || form?.getAttribute('id')?.replace('quick-add-', '');
      if (!link || !/^\d+$/.test(productId || '')) return;
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
      const control = labelTemplate.content.firstElementChild.cloneNode(true);
      const input = control.querySelector('input');
      input.id = `vwd-compare-${productId}-${++sequence}`;
      input.dataset.productId = productId;
      input.dataset.productUrl = url.pathname;
      control.querySelector('label').htmlFor = input.id;
      card.prepend(control);
    });
    sync();
  };
  const roots = document.querySelectorAll('#cm-collection-page, #cm-search-page, #cm_results');
  roots.forEach(root => {
    addControls(root);
    let pending = false;
    new MutationObserver(records => {
      if (pending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('product-card') || node.querySelector?.('product-card'))))) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; addControls(root); });
    }).observe(root, { childList: true, subtree: true });
  });
  sync();
  document.addEventListener('change', async event => {
    const input = event.target;
    if (!input.matches('.vwd-compare-control .js-compare-checkbox')) return;
    if (customElements.get('compare-drawer') && customElements.get('compare-modal')) return;
    event.stopImmediatePropagation();
    const checked = input.checked;
    input.disabled = true;
    try {
      await ensureReady();
      input.checked = checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch {
      input.checked = false;
      input.closest('.vwd-compare-control').querySelector('[role="status"]')?.removeAttribute('hidden');
    } finally {
      input.disabled = false;
    }
  }, true);
  window.addEventListener('pageshow', sync);
  if ((theme.storageUtil.get('compare-products', true) || []).length) ensureReady().catch(() => {});
})();
